<template>
  <div class="foot-page">
      <p class="mb10">{{$t('news')}}</p>
      <div class="flex-style input-style">
          <el-input v-model="email" :placeholder="$t('enterEmail')"/>
          <img src="@/assets/enter.png" @click="subscribe" class="enter"/>
      </div>

      <div class="tip" v-if="msg">{{msg}}</div>
       <div class="flex-style marginV" >
          <img
              v-for="item in iconList"
              :key="item.id"
              :src="item.icon"
              @click="opener(item)"
              class="icon-style"/>
      </div>

      <div class="link-column">
          <div 
            class="item-row" 
            v-for="item in linkList" 
            :key="item.id" 
            @click="selectItem(item)">
            <div class="space-between">
                <span>{{item.name}}</span>
                <i :class="item.id == selectId?'el-icon-arrow-down':'el-icon-arrow-right'" style="font-size: 23px;color:#FFF"></i>
            </div>
            <p 
            v-if="item.id == selectId" 
            @click="tolink(items)"
            v-for="items in item.chidren" 
            :key="items.id">{{items.name}}</p>

          </div>
      </div>

      <p class="contact">{{$t('contactUs')}}</p>
      <a href="mailto:speediance@speediance.com" class="contact-email">speediance@speediance.com</a>
      <p class="contact-info">
       {{$t('address')}}
        </p>
        <a class="contact-info" href="tel:+8613302467026">（+86）133 0246 7026</a>
        <img src="@/assets/card2.png" class="card2" alt="">
      <div class="flex-column bottom-fix">
          <img src="@/assets/bottom-logo.png" class="bottom-logo" @click="$router.push('/')"/>
          <div class="copy-right">{{$t('rights')}}</div>
      </div>
  </div>
</template>

<script>
import service from '@/api/ajax'
export default {
    data () {
        return{
            selectId:'',
            email:'',
            msg:'',
            visible:false,
            service:'',
            linkList:[
                {
                    id:1,
                    name:this.$t('PRODUCT'),
                    chidren:[
                        {
                            id:2,
                            name:this.$t('Speediance'),
                            path:'/'
                        },
                         {
                            id:3,
                            name:this.$t('Shopping'),
                            path:'/shopping'
                        },
                         // {
                        //     id:12,
                        //     name:this.$t('App'),
                        //     path:'/downloadApp'
                        // }
                    ]
                },
                {
                    id:4,
                    name:this.$t('SUPPORT'),
                    chidren:[
                        {
                           id:5,
                           name:this.$t('faq'),
                           path:'/faq'
                        },
                         {
                            id:6,
                            name:this.$t('policy'),
                            path:'/service?type=1'
                        },
                        {
                            id:13,
                            name:this.$t('service'),
                            path:'/service?type=5'
                        },
                        {
                            id:14,
                            name:this.$t('Shipping Policy'),
                            path:'/service?type=6'
                        },
                         {
                            id:15,
                            name:this.$t('Membership'),
                            path:'/service?type=4'
                        },
                    ]
                },
                {
                    id:7,
                    name:this.$t('ABOUT'),
                    chidren:[
                        {
                            id:8,
                            name:this.$t('AboutUs'),
                            path:'/aboutUs'
                        },
                         {
                            id:9,
                            name:this.$t('blog'),
                            path:'/blog'
                        },
                         {
                            id:10,
                            name:this.$t('affiliate'),
                            path:'/shareAsale'
                        },
                         {
                            id:11,
                            name:this.$t('dealer'),
                            path:'/become-a-speediance-dealer'
                        }
                    ]
                }
            ],
            iconList:[
                {
                    id:1,
                    icon:require('@/assets/link1.png'),
                    link:'https://www.instagram.com/speediance_official/'
                },
                 {
                    id:2,
                    icon:require('@/assets/link2.png'),
                    link:'https://www.facebook.com/profile.php?id=100073263667860'
                },
                 {
                    id:3,
                    icon:require('@/assets/link3.png'),
                    link:'https://www.youtube.com/channel/UC1hBBtmHjg7iaa0gAS0Zk4A'
                },
                 {
                    id:4,
                    icon:require('@/assets/link4.png'),
                    link:'https://www.linkedin.com/company/%E9%80%9F%E5%A2%83%E7%94%9F%E6%B4%BBspeediance/'
                },
                 {
                    id:5,
                    icon:require('@/assets/link5.png'),
                    link:'https://www.tiktok.com/@speediance?'
                },
                 {
                    id:6,
                    icon:require('@/assets/link6.png'),
                    link:'https://www.pinterest.com/media0906/'
                }
            ]
        }
    },
    created () {
        console.log('foot--------------------')
    },
    methods:{
        selectItem (item) {
            if(this.selectId == item.id) {
                this.selectId = ''
            }else{
                this.selectId = item.id
            }
        },
         subscribe () {
            this.msg =''
            let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
            if(!reg.test(this.email)){
                this.msg = this.$t('validEmail')
                return
            }
            let json = {
                email:this.email,
                origin:'官网底部订阅'
            }
            service.post('/manage/officialWebsite/collectionEmail/commit',json).then((res)=>{
                console.log(res)
                if(res.code == 0) {
                    this.email = ''
                    this.msg = 'Success!'
                }else{
                    this.msg = res.message
                }
            })
        },
        opener (item) {
            window.open(item.link,'_blank')
        },
        tolink (item) {
            if(!item.path){
                this.getService()
            }else{
                this.$router.push(item.path)
            }
        },
        close (val) {
            this.visible  = val
        }
    }
}
</script>

<style lang='less' scoped>
    .flex-style{
        display: flex;
        align-items: center;
    }
    .space-between{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .mt40{
        margin-top: 40px;
    }
    .foot-page{
        width: 100%;
        background: #000000;
        padding: 40px;
        box-sizing: border-box;
        display: flex;
        flex-flow: column wrap;
        .link-style{
            color: #FFF;
            font-size: 28px;
            margin-right: 50px;
            cursor: pointer;
            &:last-child{
                margin-right: 0;
            }
        }
        .icon-style{
            width: 47px;
            height: 47px;
            margin-right: 17px;
            cursor: pointer;
        }
        .marginV{
          margin-top: 30px;
          margin-bottom: 30px;
        }
        .input-style{
          position: relative;
          margin-top: 15px;
          width: 380px;
          height: 70px;
            /deep/.el-input__inner{
                background: #212121;
                height: 70px;
                border: none;
            }
            img{
                width: 30px;
                height: 30px;
                cursor: pointer;
            }
            .enter{
              width: 36px;
              height: 36px;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 15px;
            }
        }
        .contact{
            line-height: 38px;
            font-size: 30px;
            margin-bottom: 20px;
            color: #808080;
            margin-top: 60px;
        }
        .contact-email{
            font-size: 26px;
            color: #FFF;
        }
        .contact-info{
            line-height: 40px;
            font-size: 26px;
            color: #FFF;
            width: 50%;
            margin-top: 30px;
        }
        .card2{
            height: 56px;
            width: 432px;
            margin-top: 30px;
            margin-bottom: 40px;
        }
        .link-column{
            display: flex;
            flex-flow: column wrap;
            .item-row{
                padding: 30px 0;
                border-bottom: 1px solid #FFF;
                font-family: SFProDisplayBold;
                color: #808080;
                font-size: 30px;
                p{
                    margin-top: 40px;
                    font-size: 28px;
                    color: #FFF;
                    font-family: SFProDisplayMedium;
                }
            }
        }
    }
    .bottom-fix{
        .bottom-logo{
            width: 249px;
            height: 39px;
        }
        .copy-right{
            font-size: 20px;
            color: #757575;
            margin-top: 20px;
            line-height: 38px;
        }
    }
  .tip{
      color: red;
      margin-top: 10px;
      font-size: 16px;
  }

  .mb10 {
    margin-bottom: 10px;
    color: #FFF;
  }

  .mt98 {
    margin-top: 98px;
  }
  .mt20{
      margin-top: 40px;
      color: #FFF;
      font-size: 28px;
      cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue